<div class="modal" tabindex="-1">
    <div class="modal-dialog modal-fullscreen-lg-down modal-lg">
        <div class="modal-content p-0">
            <div class="modal-body">
                <button
                    type="button" (click)="close()"
                    class="btn-close"
                    style="position: absolute; top:15px; right: 15px; z-index: 1"></button>
                <h3 class="fs-3 fw-bold text-center my-5">
                    Colour variations
                </h3>
                <div class="px-lg-4 px-xl-5" *ngIf="product">
                    <div class="row align-items-center mb-5">
                        <div class="col-2">
                            <button *ngIf="pos > 0"
                                    class="btn-blank"
                                    (click)="navBack()">
                                <svg-icon
                                    src="assets/images/icon-arrow-slider-left.svg"
                                    [svgClass]="'icon-variants--arrow'"
                                    [style.fill]="arrowColour">
                                </svg-icon>
                            </button>
                        </div>
                        <div class="col-8">
                            <div class="d-flex flex-column justify-content-between align-items-center">
                                <div class="border-1 border-light p-2 mb-3 mb-lg-4">
                                    <img [src]="product.colourImages[pos].url"
                                         [appScrset]="product.colourImages[pos].url"
                                         [width]="300"
                                         class="img-preview img-fluid">
                                </div>
                                <div class="d-flex flex-column">
                                    <p class="text-muted small">
                                        Colour variation {{pos + 1}} of {{product.colourImages.length}}
                                    </p>
                                    <p class="ff-spectral fw-bold text-primary">
                                        {{product.colourImages[pos].description}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <button *ngIf="pos < product.colourImages.length -1"
                                    class="btn-blank"
                                    (click)="navForward()">
                                <svg-icon
                                    src="assets/images/icon-arrow-slider-right.svg"
                                    [svgClass]="'icon-variants--arrow'"
                                    [style.fill]="arrowColour">
                                </svg-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
